<template>
    <div style="width: 100%; height: 100%; margin: 0; padding: 20px; overflow-y: auto; text-align: left; box-sizing: border-box;">
        <side-menu-header :role="store.state.user.role"></side-menu-header>
        <img v-if="!isMobile()" class="contact-side-img" src="./../../assets/contact_us_side.png"/>
        <div v-if="contactus == 1">
            <contact-us-page1 @contactpage2='contactus++'></contact-us-page1>
        </div>
        <div v-else>
            <contact-us-page2></contact-us-page2>
        </div>
    </div>
</template>

<script>
import SideMenuHeader from './../design/SideMenuHeader.vue'
import store from '@store/index.js'
import ContactUsPage1 from './../../views/advertiser/ContactUsPage1.vue'
import ContactUsPage2 from './../../views/advertiser/ContactUsPage2.vue'
export default {
  name: 'ContactUs',
  components: {
    ContactUsPage1,
    ContactUsPage2,
    SideMenuHeader
  },
  data: function () {
    return {
      contactus: 1,
      store: store
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.contact-side-img{
    position: relative;
    right: 0px;
    float: right;
    z-index: -1;
    width: 405px;
}

@media only screen and (max-width: 1200px) {
  .contact-side-img {
    width: 170px;
  }
}

@media only screen and (max-width: 600px) {
  .contact-side-img{
    /* display: none; */
    margin-bottom: -50px;
  }
}
</style>